import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  Link,
} from "react-router-dom";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import {
  getUserDesignFeedApi,
} from "../api/DesignActions";

const Profilephoto: React.FC = () => {
  const [
    photos,
    setPhotos,
  ] = useState<any[]>([]);

  const [
    isOpen,
    setIsOpen,
  ] = useState(false);

  const [
    photoIndex,
    setPhotoIndex,
  ] = useState(0);

  const [
    loading,
    setLoading,
  ] = useState(false);

  // ==========================
  // CURRENT USER
  // ==========================
  const user = JSON.parse(
    localStorage.getItem(
      "user"
    ) || "{}"
  );

  // ==========================
  // FETCH DESIGN PHOTOS
  // ==========================
  const fetchDesignPhotos =
    async () => {
      if (
        !user?.user_id
      ) {
        setPhotos([]);
        return;
      }

      try {
        setLoading(true);

        const result =
          await getUserDesignFeedApi(
            user.user_id,
            1,
            4
          );

        if (
          result?.success ===
            false ||
          result?.status ===
            false
        ) {
          setPhotos([]);
          return;
        }

        setPhotos(
          Array.isArray(
            result?.data
          )
            ? result.data
            : []
        );
      } catch (error) {
        console.error(
          "Design photos fetch error:",
          error
        );

        setPhotos([]);
      } finally {
        setLoading(false);
      }
    };

  // ==========================
  // INITIAL LOAD
  // ==========================
  useEffect(() => {
    fetchDesignPhotos();

    // eslint-disable-next-line
  }, [user?.user_id]);

  // ==========================
  // NORMALIZED PHOTOS
  // ==========================
  const posterItems =
    useMemo(
      () =>
        photos
          .map(
            (
              photo,
              index
            ) => ({
              ...photo,

              imageUrl:
                photo.image_url ||
                photo.api_image_url ||
                "",

              originalIndex:
                index,
            })
          )
          .filter(
            (photo) =>
              Boolean(
                photo.imageUrl
              )
          ),
      [photos]
    );

  // ==========================
  // OPEN LIGHTBOX
  // ==========================
  const openLightbox = (
    index: number
  ) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  // ==========================
  // LIGHTBOX SLIDES
  // ==========================
  const slides =
    posterItems.map(
      (photo) => ({
        src:
          photo.imageUrl,
      })
    );

  return (
    <div className="bs-posters-card">
      {/* ==========================
          HEADER
      ========================== */}
      <div className="bs-posters-header">
        <div className="bs-posters-title-wrap">
          <div className="bs-posters-title-icon">
            <i className="feather-image" />
          </div>

          <h4>
            Posters
          </h4>
        </div>

        <Link
          to="/designs/poster"
          className="bs-posters-seeall"
        >
          See all

          <i className="feather-arrow-right" />
        </Link>
      </div>

      {/* ==========================
          LOADING
      ========================== */}
      {loading && (
        <div className="bs-posters-grid">
          {Array.from({
            length: 4,
          }).map(
            (_, index) => (
              <div
                key={index}
                className="bs-posters-skeleton"
              />
            )
          )}
        </div>
      )}

      {/* ==========================
          EMPTY STATE
      ========================== */}
      {!loading &&
        posterItems.length ===
          0 && (
          <div className="bs-posters-empty">
            <div className="bs-posters-empty-icon">
              <i className="feather-image" />
            </div>

            <h5>
              No posters yet
            </h5>

            <p>
              Creative posters from
              your clubs will appear
              here.
            </p>

            <Link
              to="/designs/poster"
              className="bs-posters-explore"
            >
              Browse Posters

              <i className="feather-arrow-right" />
            </Link>
          </div>
        )}

      {/* ==========================
          POSTER GRID
      ========================== */}
      {!loading &&
        posterItems.length >
          0 && (
          <div className="bs-posters-grid">
            {posterItems
              .slice(0, 4)
              .map(
                (
                  photo,
                  index
                ) => (
                  <button
                    type="button"
                    key={
                      photo.design_id ||
                      index
                    }
                    className="bs-poster-item"
                    onClick={() =>
                      openLightbox(
                        index
                      )
                    }
                    aria-label={
                      photo.design_title ||
                      `Open poster ${
                        index +
                        1
                      }`
                    }
                  >
                    <img
                      src={
                        photo.imageUrl
                      }
                      alt={
                        photo.design_title ||
                        `Poster ${
                          index +
                          1
                        }`
                      }
                      onError={(
                        event
                      ) => {
                        event.currentTarget.style.display =
                          "none";
                      }}
                    />

                    <div className="bs-poster-overlay">
                      <span className="bs-poster-view">
                        <i className="feather-maximize-2" />
                      </span>
                    </div>

                    {photo.design_title && (
                      <div className="bs-poster-caption">
                        {
                          photo.design_title
                        }
                      </div>
                    )}
                  </button>
                )
              )}
          </div>
        )}

      {/* ==========================
          FOOTER ACTION
      ========================== */}
      {!loading &&
        posterItems.length >
          0 && (
          <div className="bs-posters-footer">
            <Link
              to="/designs/poster"
              className="bs-posters-more"
            >
              <i className="feather-grid" />

              View all posters
            </Link>
          </div>
        )}

      {/* ==========================
          LIGHTBOX
      ========================== */}
      {isOpen &&
        slides.length >
          0 && (
          <Lightbox
            open={
              isOpen
            }
            close={() =>
              setIsOpen(
                false
              )
            }
            index={
              photoIndex
            }
            slides={
              slides
            }
          />
        )}

      <style>{`
        /* ==========================================
           POSTERS CARD
        ========================================== */

        .bs-posters-card {
          width: 100%;
          margin-bottom: 18px;

          border:
            1px solid #E5EBF5;

          border-radius:
            18px;

          background:
            #FFFFFF;

          box-shadow:
            0 8px 28px
            rgba(
              10,
              35,
              84,
              0.05
            );

          overflow:
            hidden;
        }

        /* ==========================================
           HEADER
        ========================================== */

        .bs-posters-header {
          display:
            flex;

          align-items:
            center;

          justify-content:
            space-between;

          gap:
            12px;

          padding:
            16px 18px 12px;
        }

        .bs-posters-title-wrap {
          display:
            flex;

          align-items:
            center;

          gap:
            8px;
        }

        .bs-posters-title-icon {
          display:
            flex;

          align-items:
            center;

          justify-content:
            center;

          width:
            30px;

          height:
            30px;

          flex-shrink:
            0;

          border-radius:
            9px;

          background:
            #FFF4EB;

          color:
            #F59E0B;

          font-size:
            14px;
        }

        .bs-posters-header h4 {
          margin:
            0;

          color:
            #0A2354;

          font-size:
            14px;

          font-weight:
            700;
        }

        .bs-posters-seeall {
          display:
            inline-flex;

          align-items:
            center;

          gap:
            4px;

          flex-shrink:
            0;

          color:
            #2F6FE4;

          font-size:
            11.5px;

          font-weight:
            700;

          text-decoration:
            none;

          transition:
            0.15s ease;
        }

        .bs-posters-seeall i {
          font-size:
            12px;

          transition:
            transform
            0.15s ease;
        }

        .bs-posters-seeall:hover {
          color:
            #1447B0;
        }

        .bs-posters-seeall:hover i {
          transform:
            translateX(2px);
        }

        /* ==========================================
           GRID
        ========================================== */

        .bs-posters-grid {
          display:
            grid;

          grid-template-columns:
            repeat(2, minmax(0, 1fr));

          gap:
            8px;

          padding:
            0 12px 12px;
        }

        .bs-poster-item {
          position:
            relative;

          display:
            block;

          width:
            100%;

          aspect-ratio:
            1 / 0.78;

          overflow:
            hidden;

          padding:
            0;

          border:
            0;

          border-radius:
            13px;

          background:
            #F4F7FC;

          cursor:
            pointer;

          box-shadow:
            0 4px 12px
            rgba(
              10,
              35,
              84,
              0.06
            );

          transition:
            transform
            0.18s ease,
            box-shadow
            0.18s ease;
        }

        .bs-poster-item:hover {
          transform:
            translateY(-2px);

          box-shadow:
            0 10px 22px
            rgba(
              10,
              35,
              84,
              0.11
            );
        }

        .bs-poster-item img {
          display:
            block;

          width:
            100%;

          height:
            100%;

          object-fit:
            cover;

          transition:
            transform
            0.25s ease;
        }

        .bs-poster-item:hover img {
          transform:
            scale(1.045);
        }

        .bs-poster-overlay {
          position:
            absolute;

          inset:
            0;

          display:
            flex;

          align-items:
            center;

          justify-content:
            center;

          background:
            linear-gradient(
              180deg,
              transparent 35%,
              rgba(
                6,
                23,
                51,
                0.42
              )
            );

          opacity:
            0;

          transition:
            opacity
            0.18s ease;
        }

        .bs-poster-item:hover
        .bs-poster-overlay {
          opacity:
            1;
        }

        .bs-poster-view {
          display:
            flex;

          align-items:
            center;

          justify-content:
            center;

          width:
            34px;

          height:
            34px;

          border:
            1px solid
            rgba(
              255,
              255,
              255,
              0.5
            );

          border-radius:
            50%;

          background:
            rgba(
              255,
              255,
              255,
              0.92
            );

          color:
            #0A2354;

          font-size:
            13px;

          transform:
            scale(0.9);

          transition:
            transform
            0.18s ease;
        }

        .bs-poster-item:hover
        .bs-poster-view {
          transform:
            scale(1);
        }

        .bs-poster-caption {
          position:
            absolute;

          left:
            8px;

          right:
            8px;

          bottom:
            7px;

          overflow:
            hidden;

          color:
            #FFFFFF;

          font-size:
            9.5px;

          font-weight:
            700;

          text-align:
            left;

          white-space:
            nowrap;

          text-overflow:
            ellipsis;

          text-shadow:
            0 1px 4px
            rgba(
              0,
              0,
              0,
              0.35
            );

          pointer-events:
            none;
        }

        /* ==========================================
           FOOTER
        ========================================== */

        .bs-posters-footer {
          padding:
            0 12px 14px;
        }

        .bs-posters-more {
          display:
            flex;

          align-items:
            center;

          justify-content:
            center;

          gap:
            6px;

          min-height:
            36px;

          width:
            100%;

          border-radius:
            11px;

          background:
            #F4F7FC;

          color:
            #0A2354;

          font-size:
            11px;

          font-weight:
            700;

          text-decoration:
            none;

          transition:
            0.15s ease;
        }

        .bs-posters-more:hover {
          background:
            #EEF4FF;

          color:
            #2F6FE4;
        }

        /* ==========================================
           EMPTY STATE
        ========================================== */

        .bs-posters-empty {
          display:
            flex;

          flex-direction:
            column;

          align-items:
            center;

          padding:
            8px 18px 22px;

          text-align:
            center;
        }

        .bs-posters-empty-icon {
          display:
            flex;

          align-items:
            center;

          justify-content:
            center;

          width:
            48px;

          height:
            48px;

          margin-bottom:
            10px;

          border-radius:
            14px;

          background:
            linear-gradient(
              135deg,
              #FFF4EB,
              #FFF9F2
            );

          color:
            #F59E0B;

          font-size:
            20px;
        }

        .bs-posters-empty h5 {
          margin:
            0;

          color:
            #0A2354;

          font-size:
            13px;

          font-weight:
            700;
        }

        .bs-posters-empty p {
          max-width:
            210px;

          margin:
            5px 0 12px;

          color:
            #8A93A3;

          font-size:
            11px;

          line-height:
            1.5;
        }

        .bs-posters-explore {
          display:
            inline-flex;

          align-items:
            center;

          justify-content:
            center;

          gap:
            5px;

          min-height:
            32px;

          padding:
            0 14px;

          border-radius:
            999px;

          background:
            #FFF4EB;

          color:
            #D97706;

          font-size:
            11px;

          font-weight:
            700;

          text-decoration:
            none;

          transition:
            0.15s ease;
        }

        .bs-posters-explore:hover {
          background:
            #F59E0B;

          color:
            #FFFFFF;
        }

        /* ==========================================
           LOADING SKELETON
        ========================================== */

        .bs-posters-skeleton {
          aspect-ratio:
            1 / 0.78;

          border-radius:
            13px;

          background:
            linear-gradient(
              90deg,
              #EDF2F9 25%,
              #F8FAFD 37%,
              #EDF2F9 63%
            );

          background-size:
            400% 100%;

          animation:
            bs-posters-shimmer
            1.3s ease
            infinite;
        }

        @keyframes bs-posters-shimmer {
          0% {
            background-position:
              100% 0;
          }

          100% {
            background-position:
              -100% 0;
          }
        }

        /* ==========================================
           RESPONSIVE
        ========================================== */

        @media (
          max-width:
            575px
        ) {
          .bs-posters-header {
            padding:
              14px 14px 10px;
          }

          .bs-posters-grid {
            gap:
              7px;

            padding:
              0 10px 10px;
          }

          .bs-posters-footer {
            padding:
              0 10px 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default Profilephoto;
